/**
 * Default carousel section order for the homepage
 * This order is used when the Lab feature flag for carousel reordering is not enabled
 */
export type HomepageCarouselSectionIdentifier =
  App.LabCarouselSectionOrderPayload['sectionOrder'][number]

export const DEFAULT_CAROUSEL_ORDER: Array<HomepageCarouselSectionIdentifier> = [
  'componentBannerGroup',
  'upsellSection',
  'frontPageUSP',
  'carHireBundledUpcomingOrder',
  'trendingDestinations',
  'maldivesCharterCarousel',
  'offerEndingSoonCarousel',
  'topPicksForMeCarousel',
  'homepageFlightCampaigns',
  'homepageFlightDeals',
  'societeStayUpgradeCarousel',
  'tourOfferCarousel',
  'supportTile',
  'cruiseOfferCarousel',
  'trustIndicatorSection',
  'experienceLuxPlusCarousel',
  'smartExperienceOfferCarousel',
  'marketingCarousel',
  'luxPlusOfferCarousel',
  'hotelOfferCarousel',
  'ultraLuxOfferCarousel',
  'merchandisePointsCarousel',
  'valuePropositionBanner',
  'blogCarousel',
  'browseOfferTypes',
]
